import React, { useContext, useState } from "react";
import {
  Checkbox,
  DefaultButton,
  DirectionalHint,
  Dropdown,
  IconButton,
  Modal,
  PrimaryButton,
  ResponsiveMode,
  TextField,
} from "@fluentui/react";
import "./ReturnStudyModal.css";
import ModalHeader from "../../../../components/Modal/ModalHeader";
import ModalFooter from "../../../../components/Modal/ModalFooter";
import { useTranslation } from "react-i18next";
import { ReturnStudyApi } from "../../../../service/StudyViewerService";
import studyviewerContext from "../../../../context/studyviewer/StudyviewerContext";
import studyReportContext from "../../../../context/studyreport/StudyReportContext";
import ModalMain from "../../../../components/Modal/ModalMain";
import themeContext from "../../../../context/theme/ThemeContext";
import { isMobile } from "react-device-detect";
import { getEnv } from "../../../../helpers/EnvHelper";

const ReturnStudyModal = (props) => {
  const { t } = useTranslation();
  const isVdcPlatform = getEnv("REACT_APP_VDC_PLATFORM") === "true";

  const { studyParentId, patientStudyData, studyResponseData, returnReasonList } = useContext(studyviewerContext);
  const { unlockStudy } = useContext(studyReportContext);
  const [errorMessage, setErrorMessage] = useState("");
  const [isError, setIsError] = useState(false);
  const { getThemeColor } = useContext(themeContext);
  const [isOtherReason, setIsOtherReason] = useState(false);
  // const reasonsList = [
  //   { key: "Case out of scope", text: t("return-study-reasons.case-out-of-scope") },
  //   { key: "Study out of scope", text: t("return-study-reasons.study-out-of-scope") },
  //   { key: "Poor Quality", text: t("return-study-reasons.poor-quality") },
  //   {
  //     key: "Incomplete study",
  //     text: t("return-study-reasons.incomplete-study"),
  //   },
  //   {
  //     key: "Inadequate history",
  //     text: t("return-study-reasons.inadequate-history"),
  //   },
  //   {
  //     key: "Need aditional information/documentation",
  //     text: t("return-study-reasons.need-info"),
  //   },
  //   {
  //     key: "Unable to come to a conclusion on diagnosis",
  //     text: t("return-study-reasons.not-concluded"),
  //   },
  //   { key: "Lack of time", text: t("return-study-reasons.lack-of-time") },
  //   { key: "Scan not normal", text: t("return-study-reasons.not-normal") },
  //   {
  //     key: "Reference / CT cuts",
  //     text: t("return-study-reasons.reference-CT-cuts"),
  //   },
  //   {
  //     key: "Not for reporting",
  //     text: t("return-study-reasons.not-for-reporting"),
  //   },
  //   { key: "Double entry", text: t("return-study-reasons.double-entry") },
  //   { key: "Other", text: t("return-study-reasons.other") },
  // ];

  const reasonsList = [
    ...(import.meta.env.VITE_VDC_PLATFORM === "true" || import.meta.env.VITE_VDC_PLATFORM === true
      ? [
        { key: "Case out of scope", text: t("return-study-reasons.case-out-of-scope") },
        { key: "Study out of scope", text: t("return-study-reasons.study-out-of-scope") },
        { key: "Poor Quality", text: t("return-study-reasons.poor-quality") },
        { key: "Incomplete study", text: t("return-study-reasons.incomplete-study"),},
        { key: "Inadequate history", text: t("return-study-reasons.inadequate-history"),},
        { key: "Need aditional information/documentation", text: t("return-study-reasons.need-info"),},
        { key: "Unable to come to a conclusion on diagnosis", text: t("return-study-reasons.not-concluded"),},
        { key: "Lack of time", text: t("return-study-reasons.lack-of-time") },
        { key: "Scan not normal", text: t("return-study-reasons.not-normal") },
        { key: "Reference / CT cuts", text: t("return-study-reasons.reference-CT-cuts"),},
        { key: "Not for reporting", text: t("return-study-reasons.not-for-reporting"),},
        { key: "Double entry", text: t("return-study-reasons.double-entry") },
        { key: "Other", text: t("return-study-reasons.other") },
      ]
      : [
        { key: "Not having expertise to report", text: t("return-study-reasons-2.no-expertise") },
        { key: "Poor quality", text: t("return-study-reasons-2.poor-quality") },
        { key: "Incomplete study", text: t("return-study-reasons-2.incomplete-study") },
        {
          key: "Inadequate clinical details. Need detail history",
          text: t("return-study-reasons-2.inadequate-history"),
        },
        { key: "Lack of time", text: t("return-study-reasons-2.lack-of-time") },
        {
          key: "Reference / CT cuts",
          text: t("return-study-reasons-2.reference-CT-cuts"),
        },
        { key: "Double entry", text: t("return-study-reasons-2.double-entry") },
        { key: "Other", text: t("return-study-reasons-2.other") },]),
  ];

  const mobileReasonsList = [
    ...(import.meta.env.VITE_VDC_PLATFORM === "true" || import.meta.env.VITE_VDC_PLATFORM === true
      ? [
        { key: "Case out of scope", text: t("return-study-reasons.case-out-of-scope") },
        { key: "Study out of scope", text: t("return-study-reasons.study-out-of-scope") },
        { key: "Poor Quality", text: t("return-study-reasons.poor-quality") },
        { key: "Incomplete study", text: t("return-study-reasons.incomplete-study"),},
        { key: "Inadequate history", text: t("return-study-reasons.inadequate-history"),},
        { key: "Need aditional information/documentation", text: t("return-study-reasons.need-info"),},
        { key: "Unable to come to a conclusion on diagnosis", text: t("return-study-reasons.not-concluded"),},
        { key: "Lack of time", text: t("return-study-reasons.lack-of-time") },
        { key: "Scan not normal", text: t("return-study-reasons.not-normal") },
        { key: "Reference / CT cuts", text: t("return-study-reasons.reference-CT-cuts"),},
        { key: "Not for reporting", text: t("return-study-reasons.not-for-reporting"),},
        { key: "Double entry", text: t("return-study-reasons.double-entry") },
        { key: "Other", text: t("return-study-reasons.other") },
      ]
      : [
        { key: "Poor Quality", text: t("return-study-reasons.poor-quality") },
        {
          key: "Incomplete study",
          text: t("return-study-reasons.incomplete-study"),
        },
        {
          key: "Inadequate history",
          text: t("return-study-reasons.inadequate-history"),
        },
        {
          key: "Need aditional information/documentation",
          text: t("return-study-reasons.need-info"),
        },
        {
          key: "Unable to come to a conclusion on diagnosis",
          text: t("return-study-reasons.not-concluded"),
        },
        { key: "Lack of time", text: t("return-study-reasons.lack-of-time") },
        { key: "Scan not normal", text: t("return-study-reasons.not-normal") },
        {
          key: "Reference / CT cuts",
          text: t("return-study-reasons.reference-CT-cuts"),
        },
        {
          key: "Not for reporting",
          text: t("return-study-reasons.not-for-reporting"),
        },
        { key: "Double entry", text: t("return-study-reasons.double-entry") },]),
  ];

  const [reason, setReason] = useState("select");
  const [selectedMain, setSelectedMain] = useState(null);
  const [selectedSub, setSelectedSub] = useState(null);
  const [otherReason, setOtherReason] = useState("");
  const [isOtherSelected, setIsOtherSelected] = useState(false);
  const [returnOtherStudiesInGroup, setReturnOtherStudiesInGroup] = useState(false);
  
  const hideReturnStudyModal = () => {
    props.setShowReturnStudyModal(false);
  };

  const handleMainChange = (event, option) => {
    setSelectedMain(option.key);
    setSelectedSub(null);
    setOtherReason("");

     setIsError(false);
     setErrorMessage("");

    if (option.key === "OTHER") {
      setIsOtherSelected(true);
    } else {
      setIsOtherSelected(false);
    }
  };

  const getMainCategoryOptions = () => {
    const sortedMain = [...(returnReasonList || [])]
      .sort((a, b) => a.displayOrder - b.displayOrder);

    const options = sortedMain.map((item) => ({
      key: item.mainId,
      text: item.mainName,
    }));

    return [
      // { key: "select", text: "Select" },
      ...options,
      { key: "OTHER", text: "Other" }, 
    ];
  };

  const getSelectedMainData = () => {
    return returnReasonList?.find(
      (item) => item.mainId === selectedMain
    );
  };

  const getSubCategoryOptions = () => {
    const main = getSelectedMainData();
    if (!main || !main.subCategories?.length) return [];

    const sortedSub = [...main.subCategories]
      .sort((a, b) => a.displayOrder - b.displayOrder);

    return [
      // { key: "select", text: "Select" },
      ...sortedSub.map((sub) => ({
        key: sub.id,
        text: sub.name,
      })),
    ];
  };

  let PrimaryButtonList = [
    {
      title: t("button.yes"),
      onclick: () => {
        if (!selectedMain || selectedMain === "select") {
          setIsError(true);
          setErrorMessage("Main category is required.");
          return;
        }

        if (selectedMain === "OTHER") {
          if (!otherReason.trim()) {
            setIsError(true);
            setErrorMessage("Please enter reason.");
            return;
          }
          unlockStudy(studyParentId, true, "Other", otherReason, isVdcPlatform && returnOtherStudiesInGroup);
          return;
        }

        const selectedMainData = getSelectedMainData();
        if (selectedMainData?.subCategories?.length > 0) {
          if (!selectedSub || selectedSub === "select") {
            setIsError(true);
            setErrorMessage("Sub category is required.");
            return;
          }
          const subName = selectedMainData.subCategories.find((s) => s.id === selectedSub)?.name;
          // const finalReason = selectedMainData.mainName + " : " + subName;
          unlockStudy(studyParentId, false, selectedMainData.mainName, subName, isVdcPlatform && returnOtherStudiesInGroup);
        } else {
          unlockStudy(studyParentId, false, selectedMainData.mainName, null, isVdcPlatform && returnOtherStudiesInGroup);
        }       
      },
    },
  ];

  const requiredStyle = { color: 'red' };
  
  let DefaultButtonList = [
    {
      title: t("button.no"),
      onclick: () => {
        setIsError(false);
        hideReturnStudyModal();
      },
    },
  ];

  const modalDetails = {
    header: (
      <ModalHeader
        patientName={studyResponseData?.patientName}
        patientID={studyResponseData?.patientId}
        heading={t("return-study.studyviewer.title")}
        handleCancel={hideReturnStudyModal}
        updatedModal={true}
      />
    ),
    body: (
      <div className="return-study-container">
        <div className="return-study-content">
          <div className="ReturnStudyContentContainer">
          
            <div style={{display: "flex", flexDirection: "row"}}>
              <label style={{ color: getThemeColor("primary-color"), width: "30%", marginBottom: "5px" }}>
                Main Category
                <span style={requiredStyle}>*</span>
              </label>

              <Dropdown
                placeholder="Select main category"
                options={getMainCategoryOptions()}
                selectedKey={selectedMain}
                onChange={handleMainChange}
                responsiveMode={ResponsiveMode.large}
                calloutProps={{ directionalHint: DirectionalHint.bottomLeftEdge, directionalHintFixed: true }}
                styles={{
                  root: { width: "100%" },
                  dropdownItemsWrapper: { maxHeight: 200 },
                  // long options (e.g. "Inadequate clinical details…") were
                  // truncated with an ellipsis; mobile can't hover for the tooltip.
                  // Let the option text wrap to as many lines as needed instead.
                  dropdownOptionText: { whiteSpace: "normal", overflow: "visible", textOverflow: "clip", lineHeight: "16px" },
                  dropdownItem: { height: "auto", minHeight: 32, whiteSpace: "normal", paddingTop: 4, paddingBottom: 4 },
                  dropdownItemSelected: { height: "auto", minHeight: 32, whiteSpace: "normal", paddingTop: 4, paddingBottom: 4 },
                  // the collapsed selected value was also truncated;
                  // let the title wrap so the full selected option shows on two lines.
                  title: { whiteSpace: "normal", overflow: "visible", textOverflow: "clip", height: "auto", minHeight: 32, lineHeight: "16px", paddingTop: 4, paddingBottom: 4 },
                }}
              />
            </div>
            {!isOtherSelected && getSelectedMainData()?.subCategories?.length > 0 && (
                <div style={{display: "flex", flexDirection: "row", marginTop: "15px"}}>
                  <label style={{ color: getThemeColor("primary-color"), width: "30%", marginBottom: "5px" }}>Sub Category <span style={requiredStyle}>*</span></label>

                  <Dropdown
                    placeholder="Select sub category"
                    options={getSubCategoryOptions()}
                    selectedKey={selectedSub}
                    onChange={(e, option) => {
                      setSelectedSub(option.key);
                      setIsError(false);
                      setErrorMessage("");
                    }}
                    responsiveMode={ResponsiveMode.large}
                    calloutProps={{ directionalHint: DirectionalHint.bottomLeftEdge, directionalHintFixed: true }}
                    styles={{
                      root: { width: "100%" },
                      dropdownItemsWrapper: { maxHeight: 200 },
                      // allow long sub-category options to wrap to full text.
                      dropdownOptionText: { whiteSpace: "normal", overflow: "visible", textOverflow: "clip", lineHeight: "16px" },
                      dropdownItem: { height: "auto", minHeight: 32, whiteSpace: "normal", paddingTop: 4, paddingBottom: 4 },
                      dropdownItemSelected: { height: "auto", minHeight: 32, whiteSpace: "normal", paddingTop: 4, paddingBottom: 4 },
                      //  wrap the collapsed selected value too.
                      title: { whiteSpace: "normal", overflow: "visible", textOverflow: "clip", height: "auto", minHeight: 32, lineHeight: "16px", paddingTop: 4, paddingBottom: 4 },
                    }}
                  />
                </div>
            )}
            {isOtherSelected && (
              <div style={{display: "flex", flexDirection: "row", marginTop: "15px"}}>
                <label style={{ color: getThemeColor("primary-color"), width: "30%", marginBottom: "5px" }}>Other Reason <span style={requiredStyle}>*</span></label>

                <TextField
                  placeholder="Enter reason"
                  value={otherReason}
                  onChange={(e) => {
                    setOtherReason(e.target.value);
                    if (e.target.value.trim()) {
                      setIsError(false);
                      setErrorMessage("");
                    }
                  }}
                  styles={{root: { width: "100%" }}}
                />
              </div>
            )}
            {isVdcPlatform && (
              <div style={{ marginTop: "15px" }}>
                <Checkbox
                  label={t("return-study.studyviewer.return-other-studies-in-group")}
                  checked={returnOtherStudiesInGroup}
                  onChange={(_, checked) => setReturnOtherStudiesInGroup(!!checked)}
                  styles={{
                    root: { width: "100%" },
                    text: { color: getThemeColor("primary-color") },
                  }}
                />
              </div>
            )}
            <div
              style={{
                width: "100%",
                display: `${isError ? "flex" : "none"}`,
                justifyContent: "center",
                alignItems: "center",
                paddingTop: "10px",
              }}
            >
              <span style={{ color: "red" }}>{errorMessage}</span>
            </div>
          </div>
        </div>
      </div>
    ),
    footer: (
      <ModalFooter
        PrimaryButtonList={PrimaryButtonList}
        DefaultButtonList={DefaultButtonList}
      />
    ),
    width: "600px",
  };

  return (
    <>
      <ModalMain
        updatedModal={true}
        modalDetails={modalDetails}
        showModal={true}
      />
    </>
  );
};

export default ReturnStudyModal;
